import React from "react";
import styled, { keyframes } from "styled-components";

import { Flex } from "../../../styles/global-styles";
import { breakpoints, spacing } from "../../../../theme";
import {
  Container,
  Content,
  Column,
  Avatar,
  Name,
  HelperText,
  SocialLinks,
  ColumnHeading,
  LinkList,
  LinkListItem,
  BadgeColumn,
} from "./styles";

const SOCIAL_COUNT = 5;
const QUICK_LINK_COUNT = 4;

/** Matches ToptalBadge Outer (6px pad) + Inner (200px x ~207px content). */
const BADGE_WIDTH = 212;
const BADGE_HEIGHT = 220;

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
`;

const Bone = styled.div`
  display: block;
  background-color: rgba(255, 255, 255, 0.12);
  border-radius: ${(props) =>
    props.$circle ? "50%" : props.$radius != null ? props.$radius : "4px"};
  height: ${(props) => props.$height || "1em"};
  width: ${(props) => props.$width || "100%"};
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

const AvatarBone = styled(Bone)`
  width: 86px;
  height: 86px;
  flex-shrink: 0;
`;

const NameBone = styled(Bone)`
  height: 1em;
  width: 100%;
`;

const SocialBone = styled(Bone)`
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 0 ${spacing(3)} 0 0;
  vertical-align: top;
`;

const HelperBone = styled(Bone)`
  display: inline-block;
  vertical-align: top;
  height: 1em;
  width: ${(props) => props.$width || "70%"};
`;

const BadgeBone = styled(Bone)`
  width: ${BADGE_WIDTH}px;
  height: ${BADGE_HEIGHT}px;
  border-radius: 8px;
`;

const HeadingBone = styled(Bone)`
  height: 1em;
  width: 7.5em;
`;

const LinkBone = styled(Bone)`
  height: 1.2em;
  font-size: 16px;
  width: ${(props) => props.$width || "55%"};
  margin: ${spacing(2)} 0;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    margin: ${spacing(3)} ${spacing(0.5)};
  }
`;

const SkeletonHeading = styled(ColumnHeading)`
  line-height: 1;
`;

const FooterSkeleton = () => (
  <Container aria-hidden>
    <Content>
      <Column>
        <Flex>
          <Avatar>
            <AvatarBone $circle />
          </Avatar>
          <Name>
            <NameBone />
          </Name>
        </Flex>

        <SocialLinks>
          {Array.from({ length: SOCIAL_COUNT }, (_, index) => (
            <SocialBone key={index} $circle />
          ))}
        </SocialLinks>

        <HelperText>
          <HelperBone $width="85%" />
        </HelperText>
        <HelperText>
          <HelperBone $width="45%" />
        </HelperText>
      </Column>

      <BadgeColumn>
        <BadgeBone />
      </BadgeColumn>

      <Column>
        <SkeletonHeading as="div">
          <HeadingBone />
        </SkeletonHeading>
        <LinkList>
          {Array.from({ length: QUICK_LINK_COUNT }, (_, index) => (
            <LinkListItem key={index}>
              <LinkBone $width={index % 2 === 0 ? "48%" : "58%"} />
            </LinkListItem>
          ))}
        </LinkList>
      </Column>
    </Content>
  </Container>
);

export default FooterSkeleton;
